import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getGpExplainTitleList(params) {
  return request({
    url: URL.mdm.basicData.gpExplainTitle,
    method: 'get',
    params
  })
}

export function saveGpExplainTitle(data) {
  return request({
    url: URL.mdm.basicData.gpExplainTitle,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

export function delGpExplainTitle(uuid) {
  return request({
    url: URL.mdm.basicData.gpExplainTitle + '?uuid=' + encodeURIComponent(uuid),
    method: 'delete'
  })
}
